import type { ErrorLike } from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';

import { Snackbar } from 'common/components/Snackbar';
import { getErrorMessage } from 'common/utils/getErrorMessage';

interface IProps {
    error: CombinedGraphQLErrors | ErrorLike;
}

export const ApolloError = ({ error }: IProps) => {
    if (!CombinedGraphQLErrors.is(error)) return null;

    return (
        <>
            {!!error.errors?.length &&
                error.errors.map((graphQLError, index) => {
                    const message = getErrorMessage(graphQLError);

                    return message ? (
                        <Snackbar open key={index} message={message} />
                    ) : null;
                })}
        </>
    );
};
